import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class ValidStartTransition extends BaseModel {

}

decorate(ValidStartTransition, {
  id: observable,
  name: observable,
  description: observable,
  customActionIds: observable,
  ...ValidStartTransition.modelCreateDecoration,
  ...ValidStartTransition.modelUpdateDecoration,
});
